import {
  AiFillInfoCircle,
  FaPhoneAlt,
  ImLibrary,
  ImUser,
  ImUsers,
  IoIosSend,
  MdAccessTime,
  RiCalendarCheckFill,
} from "react-icons/all";
import { Flex, SimpleGrid, VStack } from "@chakra-ui/react";

import { DetailFrame } from "components/DetailFrame";
import { ChakraText } from "components/ChakraText";

import { IAppointmentDetails } from "../../application/types/IAppointmentDetails";
import { StatusFrame } from "./StatusFrame";

interface IProps {
  appointment: IAppointmentDetails;
}

const AppointmentDetails = ({ appointment }: IProps) => {
  return (
    <Flex>
      <VStack spacing={6} textAlign="center" m="auto">
        <ChakraText fontWeight="bold" fontSize="xl">
          Dane wizyty
        </ChakraText>
        <SimpleGrid
          columns={{
            base: 1,
            md: 2,
          }}
          spacing={2}
          w="100%"
          justifyContent="center"
        >
          <DetailFrame icon={ImLibrary} tooltipLabel="Grupa">
            <ChakraText>{appointment.groupName}</ChakraText>
          </DetailFrame>

          <DetailFrame icon={ImUsers} tooltipLabel="Kolejka">
            <ChakraText>{appointment.queueName}</ChakraText>
          </DetailFrame>

          <DetailFrame icon={RiCalendarCheckFill} tooltipLabel="Termin wizyty">
            <ChakraText>{appointment.startDate.userFormat()}</ChakraText>
          </DetailFrame>

          <DetailFrame icon={MdAccessTime} tooltipLabel="Czas wizyty">
            <ChakraText>
              {appointment.startDate.getTime()} -{" "}
              {appointment.endDate.getTime()}
            </ChakraText>
          </DetailFrame>

          <DetailFrame icon={IoIosSend} tooltipLabel="Email">
            <ChakraText>{appointment.email}</ChakraText>
          </DetailFrame>

          <DetailFrame icon={ImUser} tooltipLabel="Nazwa">
            <ChakraText>{appointment.userName || "---"}</ChakraText>
          </DetailFrame>

          <DetailFrame icon={FaPhoneAlt} tooltipLabel="Numer telefonu">
            <ChakraText>{appointment.userPhone || "---"}</ChakraText>
          </DetailFrame>
          <StatusFrame appointment={appointment} />
        </SimpleGrid>

        <DetailFrame
          icon={AiFillInfoCircle}
          w={{ base: "280px", md: "100%" }}
          tooltipLabel="Dodatkowe informacje"
          overflowWrap="anywhere"
        >
          <ChakraText>{appointment.details || "---"}</ChakraText>
        </DetailFrame>
      </VStack>
    </Flex>
  );
};

export { AppointmentDetails };
